// Timing and wording for the countdown when a room closes for an update.

/** Seconds left at which players get a reminder. */
const NOTICE_MARKS = [3000, 1800, 900, 600, 300, 120, 60, 30, 10];

/** The mark passed as the time left fell from `before` to `now`, if any. Only the latest one counts. */
export function noticeDue(before: number, now: number): number | null {
  let due: number | null = null;
  for (const mark of NOTICE_MARKS) if (before > mark && now <= mark) due = mark;
  return due;
}

export function describeLeft(seconds: number): string {
  const s = Math.round(seconds);
  if (s >= 120) return `${Math.round(s / 60)} minutes`;
  if (s >= 60) return '1 minute';
  return s === 1 ? '1 second' : `${s} seconds`;
}

/** m:ss, rounded up so that it only reads 0:00 once the time is really gone. */
export function formatClock(seconds: number): string {
  const s = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
